import { produce } from 'immer';
import {
  ADD_ACTIVITY,
  ADD_ANSWER,
  ADD_NEW_GROUP,
  ADD_QUESTION,
  ADD_SECTION,
  COTUTORS_LIST_GET,
  COURSE_CANCEL,
  COURSE_CREATE,
  COURSE_SAVING,
  COURSE_TAB_SAVE,
  COURSE_UPDATE,
  DEL_ACTIVITY,
  DEL_ACTIVITY_COPIES,
  DEL_ANSWER,
  DEL_QUESTION,
  DEL_SECTION,
  EDIT_QUIZ,
  FILE_UPLOADED,
  GROUP_LIST_GET,
  GROUP_USERS_GET,
  MODAL_QUIZ_RESET,
  QUIZ_CREATION_RESET,
  QUIZ_DETAILS_GET,
  QUIZ_GROUP_DELETED,
  REDUCED_TABS_SET,
  REMOVE_NEW_GROUP,
  SECTIONS_SET,
  SURVEY_LIST_GET,
  TABS_RESET,
  TAG_LIST_GET,
  TEMP_QUIZ_SAVE,
  TUTORS_LIST_GET,
  TUTOR_ACTIVE_TAB_SET,
  TUTOR_DISABLED_TAB_SET,
  UPDATE_ACTIVITY,
  UPDATE_ANSWER,
  UPDATE_QUESTION,
  UPDATE_SECTION,
  USERS_RESET,
  USER_LIST_GET,
} from '../actions/tutors';

const disableTabs = true;

const defaultTabs = [
  {
    label: 'Anagrafica e Panoramica',
    value: 1,
    disabled: false,
    completed: false,
    subLabel: 'Modifica',
    subIcon: 'edit-05',
  },
  {
    label: 'Attività',
    value: 2,
    disabled: disableTabs,
    completed: false,
    subLabel: 'Modifica',
    subIcon: 'edit-05',
  },
  {
    label: 'Documentazione',
    value: 3,
    disabled: disableTabs,
    completed: false,
    subLabel: 'Modifica',
    subIcon: 'edit-05',
  },
  {
    label: 'Iscrizione',
    value: 4,
    disabled: disableTabs,
    completed: false,
    subLabel: 'Modifica',
    subIcon: 'edit-05',
  },
];

const initialSection = {
  title: '',
  activities: {},
};
// const initialActivity = {
//   type: '',
//   data: {},
// };
const initialAnswer = {
  answer: '',
  is_correct: false,
};
const initialQuestion = {
  question: '',
  choice_answers: { 1: initialAnswer },
};

const initialState = {
  tutors: [],
  cotutors: [],
  // tabs
  tabs: defaultTabs,
  activeTab: 1,
  // overview tab
  tags: [],
  surveys: [],
  // activities tab
  activities: {
    secCount: 1,
    actCount: 0,
    copyCount: 1,
    sections: {
      1: initialSection,
    },
  },
  quiz: {
    qCount: 1,
    aCount: 1,
    quiz: {
      1: initialQuestion,
    },
    preview: {},
  },
  tempQuiz: {
    tqCount: 0,
    data: {},
  },
  // registration tab
  users: { filters: {}, items: [], pager: {} },
  group: {
    id: undefined,
    name: null,
    users: [],
    pager: {},
  },
  groups: { list: [], pager: {} },
  newGroupIds: [],
  excludedNewGroupIds: [],
  // draft saved when completing tab
  course: {
    editMode: false,
  },
  courseCreation: {
    saving: false,
    loading: 0,
    errors: [],
    activity_ids: [],
  },
};

const tutorsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case TUTORS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.tutors = [...response];
        break;
      }

      case COTUTORS_LIST_GET._SUCCESS: {
        const { response } = action;
        draft.cotutors = [...response];
        break;
      }

      // TABS
      case TUTOR_ACTIVE_TAB_SET: {
        if (action.tab > 0) draft.activeTab = action.tab;
        break;
      }

      case TUTOR_DISABLED_TAB_SET: {
        const newTabs = [...state.tabs];
        Object.keys(action.tabs || {}).forEach((k) => {
          newTabs[k - 1] = { ...newTabs[k - 1], ...action.tabs[k] };
        });
        draft.tabs = newTabs;
        break;
      }

      case REDUCED_TABS_SET: {
        const newTabs = [...state.tabs];
        newTabs.pop();
        draft.tabs = newTabs;
        break;
      }

      case TABS_RESET: {
        draft.tabs = initialState.tabs;
        break;
      }

      // OVERVIEW
      case TAG_LIST_GET._SUCCESS: {
        draft.tags = action.response || [];
        break;
      }

      case SURVEY_LIST_GET._SUCCESS: {
        draft.surveys = action.response || [];
        break;
      }

      // ACTIVITIES
      case SECTIONS_SET: {
        draft.activities.secCount = action.secCount;
        draft.activities.actCount = action.actCount;
        draft.activities.sections = action?.sections || {
          1: initialSection,
        };
        break;
      }
      case ADD_SECTION: {
        draft.activities.sections[state.activities.secCount + 1] =
          initialSection;
        draft.activities.secCount = state.activities.secCount + 1;
        break;
      }
      case DEL_SECTION: {
        const newSections = { ...state.activities.sections };
        delete newSections[action?.id];
        draft.activities.sections = { ...newSections };
        break;
      }
      case UPDATE_SECTION: {
        const { id, field, value } = action;
        draft.activities.sections[id][field] = value;
        break;
      }
      case ADD_ACTIVITY: {
        const { secId, activityType = '' } = action;
        const activityId = state.activities.actCount + 1;
        draft.activities.actCount = activityId;
        draft.activities.sections[secId].activities[activityId] = {
          type: activityType,
          data: {},
        };
        break;
      }
      case DEL_ACTIVITY: {
        const { secId, actId } = action;
        const newSections = { ...state.activities.sections };
        const newActivities = { ...newSections[secId].activities };
        delete newActivities[actId];
        draft.activities.sections[secId].activities = { ...newActivities };
        // remove id of deleted activity
        draft.activities.sections[secId].session_activities_ids = newSections[
          secId
        ]?.session_activities_ids?.filter((aid) => aid !== actId);
        break;
      }
      case DEL_ACTIVITY_COPIES: {
        const { sectionKey, activityKey, isSupervisor } = action;
        // get old activities
        const newActivities = {
          ...state.activities.sections[sectionKey]?.activities,
        };
        // delete activity copies (activity with type === activity_session_...)
        Object.keys(newActivities)?.forEach((actId) => {
          if (newActivities[actId]?.type?.includes('activity_session')) {
            delete newActivities[actId];
          }
        });
        // save new state
        draft.activities.sections[sectionKey].activities = newActivities;
        // remove id of deleted activity/ies
        draft.activities.sections[sectionKey].session_activities_ids =
          isSupervisor
            ? []
            : state.activities.sections[
                sectionKey
              ]?.session_activities_ids?.filter((aid) => aid !== activityKey);
        break;
      }
      case UPDATE_ACTIVITY: {
        const { secId, actId, field, value, isCopy } = action;
        if (field === 'type') {
          draft.activities.sections[secId].activities[actId].type = value;
          draft.activities.sections[secId].activities[actId].data = {};
        } else if (Object.keys(value)?.length <= 0) {
          draft.activities.sections[secId].activities[actId][field] = {};
        } else {
          draft.activities.sections[secId].activities[actId][field] = {
            ...state.activities.sections[secId].activities[actId][field],
            ...value,
          };
          if (isCopy) {
            draft.activities.sections[secId].activities[actId].isCopy = true;
            draft.activities.sections[secId].activities[actId].order =
              state.activities.copyCount + 1;
            draft.activities.copyCount = state.activities.copyCount + 1;
          }
        }
        break;
      }
      // ACTIVITIES - QUIZ
      case ADD_QUESTION: {
        draft.quiz.quiz[state.quiz.qCount + 1] = initialQuestion;
        draft.quiz.qCount = state.quiz.qCount + 1;
        break;
      }
      case DEL_QUESTION: {
        const newQuiz = { ...state.quiz.quiz };
        delete newQuiz[action?.id];
        draft.quiz.quiz = { ...newQuiz };
        break;
      }
      case UPDATE_QUESTION: {
        const { id, field, value } = action;
        draft.quiz.quiz[id][field] = value;
        break;
      }
      case ADD_ANSWER: {
        const { questionId } = action;
        const answerId = state.quiz.aCount + 1;
        draft.quiz.quiz[questionId].choice_answers[answerId] = initialAnswer;
        draft.quiz.aCount = answerId;
        break;
      }
      case DEL_ANSWER: {
        const { questionId, answerId } = action;
        const newQuiz = { ...state.quiz.quiz };
        const newAnswers = { ...newQuiz[questionId].choice_answers };
        delete newAnswers[answerId];
        draft.quiz.quiz[questionId].choice_answers = { ...newAnswers };
        break;
      }
      case UPDATE_ANSWER: {
        const { qId, aId, field, value } = action;
        draft.quiz.quiz[qId].choice_answers[aId][field] = value;
        break;
      }
      case TEMP_QUIZ_SAVE: {
        const { id, quizDetails } = action;
        draft.tempQuiz.data[id] = {
          ...quizDetails,
          choice_elements: { ...state.quiz.quiz },
          qCount: state.quiz.qCount,
          aCount: state.quiz.aCount,
        };
        draft.quiz = initialState.quiz;
        break;
      }
      case EDIT_QUIZ: {
        const { id } = action;
        draft.quiz.quiz = { ...state.tempQuiz.data[id]?.choice_elements };
        draft.quiz.qCount = state.tempQuiz.data[id]?.qCount;
        draft.quiz.aCount = state.tempQuiz.data[id]?.aCount;
        break;
      }
      case MODAL_QUIZ_RESET: {
        draft.quiz = initialState.quiz;
        break;
      }
      case QUIZ_DETAILS_GET._SUCCESS: {
        draft.quiz.preview = action.response;
        break;
      }

      // GROUPS
      case USER_LIST_GET._SUCCESS: {
        const { response, pager, payload } = action;
        draft.users.filters = response.filters || {};
        if (payload?.group_ids !== -1) {
          draft.users.items = response.items || [];
          draft.users.pager = pager || {};
        }
        break;
      }
      case GROUP_LIST_GET._SUCCESS: {
        const { items, pager } = action?.response || {};
        draft.groups.list = items || [];
        draft.groups.pager = pager || {};
        break;
      }
      case ADD_NEW_GROUP._SUCCESS: {
        draft.newGroupIds = [
          ...state.newGroupIds,
          action.response?.id?.toString(),
        ];
        draft.group = {
          ...state.group,
          id: action?.response?.id,
          title: action?.response?.title,
        };
        break;
      }
      case REMOVE_NEW_GROUP: {
        if (action?.id === 'all') {
          draft.newGroupIds = initialState.newGroupIds;
          break;
        }
        const tempNewGroups = state.newGroupIds.filter(
          (ngid) => ngid?.toString() !== action.id?.toString()
        );
        draft.newGroupIds = [...tempNewGroups];
        // delete new groups only
        if (state.newGroupIds?.includes(action?.id)) {
          draft.excludedNewGroupIds = [
            ...new Set([...state.excludedNewGroupIds, action?.id]),
          ];
        }
        break;
      }
      case USERS_RESET: {
        draft.users = initialState.users;
        draft.group = initialState.group;
        break;
      }

      case GROUP_USERS_GET._SUCCESS: {
        const { response, pager } = action;
        draft.group.users = response.items;
        draft.group.pager = pager;
        break;
      }

      // COURSE
      case COURSE_TAB_SAVE: {
        const { tabName, data, editMode } = action;
        draft.course[tabName] = data;
        if (typeof editMode === 'boolean') draft.course.editMode = editMode;
        break;
      }
      case COURSE_SAVING: {
        draft.courseCreation.saving = action.saving;
        if (action?.saving) draft.courseCreation.loading = 4;
        break;
      }
      case COURSE_UPDATE._SUCCESS:
      case COURSE_CREATE._SUCCESS: {
        // number of API calls to do after cretion: (delete group&quiz, imgs, docs)
        draft.courseCreation.loading = 3;
        draft.courseCreation.activity_ids = action.response?.activity_ids;
        draft.courseCreation.courseId = action.response?.id;
        break;
      }

      case COURSE_UPDATE._ERROR:
      case COURSE_CREATE._ERROR: {
        draft.courseCreation.loading = 3;
        draft.courseCreation.errors = ['course', 'images', 'documents'];
        break;
      }
      case QUIZ_GROUP_DELETED:
      case FILE_UPLOADED: {
        // number of API calls to do after cretion: (imgs, docs)
        draft.courseCreation.loading = action.loading;
        if (action?.error) {
          draft.courseCreation.errors = [
            ...state.courseCreation.errors,
            action.error,
          ];
        }
        break;
      }

      case QUIZ_CREATION_RESET:
      case COURSE_CANCEL._SUCCESS: {
        draft = initialState;
        break;
      }

      default:
        return state;
    }
    return draft;
  });

export default tutorsReducer;
